import React from 'react';

const GSTPopup = ({ showGstPopup, setShowGstPopup, gstBreakdownData }) => {
    if (!showGstPopup || !gstBreakdownData) return null;

    return (
        <div className="popup-overlay" onClick={() => setShowGstPopup(false)}>
            <div className="popup-box" onClick={e => e.stopPropagation()}>
                <h3 className="popup-title">GST Breakdown</h3>
                {gstBreakdownData.serviceChargeGst > 0 && (
                    <div className="popup-row">
                        <span>Service Charge GST</span>
                        <span>₹{gstBreakdownData.serviceChargeGst.toFixed(2)}</span>
                    </div>
                )}
                {gstBreakdownData.platformChargeGst > 0 && (
                    <div className="popup-row">
                        <span>Platform Charge GST</span>
                        <span>₹{gstBreakdownData.platformChargeGst.toFixed(2)}</span>
                    </div>
                )}
                {gstBreakdownData.cgst > 0 && (
                    <div className="popup-row">
                        <span>CGST</span>
                        <span>₹{gstBreakdownData.cgst.toFixed(2)}</span>
                    </div>
                )}
                {gstBreakdownData.sgst > 0 && (
                    <div className="popup-row">
                        <span>SGST</span>
                        <span>₹{gstBreakdownData.sgst.toFixed(2)}</span>
                    </div>
                )}
                <div className="popup-total">
                    <span>Total GST</span>
                    <span>₹{(gstBreakdownData.cgst + gstBreakdownData.sgst + gstBreakdownData.serviceChargeGst + gstBreakdownData.platformChargeGst).toFixed(2)}</span>
                </div>
                <button className="popup-close-btn" onClick={() => setShowGstPopup(false)}>Close</button>
            </div>
        </div>
    );
};

export default GSTPopup;